/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {getRoutePageComponent, getContextRoutePageComponent} from '../common/controller/route-page-component-registry';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import _ from 'lodash';
import {getResourceItemTitleResolves} from '../base/default-item-title-view';
import {FolioContextActionsComponent} from './folio-context-actions.component';
import {AdminResourceItemRoutePageComponent} from '../common/controller/admin-resource-item-route-page.component';
import {CreativeSetResource} from '../../components/api/resources/resource/creative-set.resource';
import {FolioResource} from '../../components/api/resources/resource/folio.resource';


export function folioStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
let rh = adnRouterHelperProvider.$get().createRouterAndChildHelper('folios.folio', FolioResource, CreativeSetResource, 'app.adv', 'app');
        $stateProvider.state(rh.listPath(), rh.list({
          views: {
            'content@app': { component: getRoutePageComponent('folio-route') }
          }
        }))
          .state(rh.newItemPath(), rh.newItem())
          .state(rh.itemPath(), rh.modelCommsItem({
            resolve: _.merge({}, getResourceItemTitleResolves('Folio'), {
              titleVariant: function() {
                return 'folio';
              },
              folioItemRouteKey: function() {
                return 'folio-item';
              },
              routeItemVariant: function() {
                return 'item';
              }
            }),
            views: {
              'content@app': {
                component: AdminResourceItemRoutePageComponent,
                bindings: {item: 'folioItemRouteKey', variant: 'routeItemVariant'}
              },
              'context@app': {
                component: FolioContextActionsComponent,
                bindings: {model: 'model', modelComms: 'modelComms', isNew: 'isNew', readOnly: 'readOnly'}
              },
              'title@app': rh.getResourceItemTitleView()
            }
          }));
  }, adnRouterHelper);
}
